<template>
    <div class="container remove-padding-margin">
        <div class="container remove-padding-margin" id="radiusOutlet">
            <div class="header-top bg-white">
                <div class="row justify-content-center align-items-center set-row w-limit">
                    <div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back">
                        <img src="../../../assets/gambar/back-blue.svg" alt="">
                    </div>
                    <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                        <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">Radius Absen</h6>
                    </div>
                    <div class="col-md-2 col-sm-2 col-2">
                    </div>
                </div>
            </div>
            <main class="w-limit flex-100" id="main-maps">
	            <div class="flex-1" style="position: relative">
		            <GmapMap
			            :center="mapCenter"
			            :zoom="outletMarker.defaultOptions.zoom"
			            :options="{ streetViewControl: false, disableDefaultUI: true }"
			            ref="map"
			            @center_changed="updateCoordinates"
			            @idle="sync"
			            class="map-container">
			            <GmapCircle
				            ref="circleRef"
				            :center=outletMarker.location
				            :radius="outletMarker.defaultOptions.radius"
				            :visible="true"
				            :options="{
				                fillColor: '#206CFF',
				                fillOpacity:0.2,
			                    strokeWeight: 1,
			                    strokeColor: '#206CFF',
			                    strokeOpacity: 0.5,
				            }"
			            />
			            <GmapMarker
				            :position="outletMarker.location"
				            :icon="iconConfig"
			            />
		            </GmapMap>
		            <div class="current-location" @click="getCurrentLocation">
			            <div class="current-location-img"></div>
		            </div>
	            </div>
	            <div class="background-white">
		                <div class="add-padding-default p-t-20 p-d-20">
			                <div class="mar-bottom-24">
				                <p class="line-height-21 letter-space-002 font-weight-600 f-16 m-d-2">
					                Radius Outlet
				                </p>
				                <p class="line-height-21 letter-space-002 f-14 f-c-midgrey m-d-16">
					                Atur <b>batas jarak</b> karyawan dapat melakukan absen di aplikasi kasir atau produksi.
				                </p>
			                </div>
			                <div v-if="!outletMarker.pinned" id="imagePreview" class="atribute set-lokasi" @click="setLokasi">
				                <div>
					                <img src="../../../assets/img/pin-outline.svg" alt="" class="m-r-8" id="logo"
					                     style="height: 20px"/>
					                <span class="f-14 f-c-blue">Lokasi Belum Diatur</span>
				                </div>
				                <p class="m-0 f-c-midgrey f-12">
					                klik disini untuk atur lokasi outlet
				                </p>
			                </div>
			
			                <div class="row m-0 align-items-center" v-if="outletMarker.pinned">
				                <div class="col-lg-9 col-md-9 col-sm-9 col-9 p-0">
					                <div class="f-14 f-c-blue nomore">
						                <img src="../../../assets/img/pin-outline.svg" class="m-r-4" alt="">
						                {{ outletMarker.address.name }}
					                </div>
				                </div>
				                <div class="col-lg-3 col-md-3 col-sm-3 col-3 p-0" v-if="validateAccess('absentSettings.update')">
					                <button class="btn btn-outline-small pull-right" @click="validateAccess('absentSettings.update') && setLokasi()">
						                Ubah
					                </button>
				                </div>
			                </div>
		                </div>
		                <div class="border-dashed" v-if="outletMarker.pinned">
			                <div class="add-padding-default p-t-20 p-d-20">
				                <div class="row m-0 align-items-center p-d-16">
					                <div class="col-lg-2 col-md-2 col-sm-2 col-2 p-0">
						                <span class="f-14 f-c-midgrey">Jarak</span>
					                </div>
					                <div class="col-lg-7 col-md-7 col-sm-7 col-7">
						                <input type="range" min="1" max="1000" v-model="radius"
						                       style="margin-top: 6px; width: 100%">
					                </div>
					                <div class="col-lg-3 col-md-3 col-sm-3 col-3 p-0 text-right">
						                <span class="f-14 f-c-blue font-weight-600">{{ radius }} </span>
						                <span class="f-14 f-c-blue font-weight-600">meter</span>
					                </div>
				                </div>
				                <button class="btn btn-login btn-long remove-margin" id="Btnsavemap"
				                        @click="validateAccess('absentSettings.update') && updateOutletLocation()">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                  v-if="isClicked === true"></span>
					                <span id="textBtnsavemap">Simpan</span>
				                </button>
			                </div>
		                </div>
	                </div>
            </main>
        </div>
        <SetLokasiOutlet
                :class="{hidesection : !isSetLokasiOutlet}"
                ref="setlokasioutletref"
                @back="thisPage"
                @setLatLng="setLatLng"
                @getCurrentLocation="getCurrentLocation"
        />
    </div>
</template>

<script>
    import SetLokasiOutlet from "./SetLokasiOutlet";

    export default {
        name: "RadiusOutlet",
        components: {SetLokasiOutlet},
        props: ["idoutlet"],
        data() {
            return {
                isSetLokasiOutlet: false,
                isClicked: false,

                radius: 5,
	            
	            mapCenter: null,
	            awaitingDrag: false,
	            
	            iconConfig: {
		            url: require('../../../assets/icons/marker-blue.svg'),
		            size: {
		            	width: 28,
			            height: 28,
			            f: "px",
			            b: "px"
		            },
		            scaledSize: {
		            	width: 28,
			            height: 28,
			            f: "px",
			            b: "px"
		            }
	            },
	            
                outletMarker: {
                    pinned: false,
                    location: {
                        lat: -6.175253729974098,
                        lng: 106.82713133905226
                    },
                    address: {
                        name: "",
                        full: "",
                    },
                    defaultOptions: {
                        zoom: 20,
                        radius: 5,
                    }
                },
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },

                isCalled: false,
            }
        },
        mounted() {
            $('body').on('DOMSubtreeModified', '#radiusOutlet', async () => {
                // if ($("#radiusOutlet").is(":visible")) {
                //     if (!this.isCalled) {
                //         this.getOutletLocation();
                //         this.isCalled = true
                //     }
                // }
              setTimeout(() => {
                  $("#main-maps").css({"min-height": "calc(100vh - 72px)"})
              }, 100)
            });
        },
	    created() {
		    this.sync()
	    },
	    watch: {
            radius: function (r) {
                this.outletMarker.defaultOptions.radius = parseInt(r)
            }
        },
        methods: {
            back() {
                this.$emit('isdetail')
                this.setMapContainer();
                this.isCalled = false
            },
            thisPage() {
                $("#radiusOutlet").show()
                this.setMapContainer();
                this.isSetLokasiOutlet = false
            },
            setLokasi() {
                $("#radiusOutlet").hide()
                this.isSetLokasiOutlet = true;
                document.documentElement.scrollTop = 0;
            },
            setLatLng(mapInfo) {
                this.thisPage()

                this.outletMarker.location = mapInfo.latlng
                this.outletMarker.address = mapInfo.address
	            this.mapCenter = this.outletMarker.location
                this.outletMarker.pinned = true

	            this.setMapContainer()
            },
            setMapContainer() {
                setTimeout(() => {
                    var sticky = $(".background-white").height();
                    $(".map-container").css({"max-height": "calc(100vh - " + (sticky + 72) + "px)"})
                    if (this.outletMarker.pinned) {
                        // this.zoomMaps();
                    }
                }, 100)
            },
            // zoomMaps() {
            //     this.$refs.circleRef.$circlePromise.then(() => {
            //         const {$circleObject} = this.$refs.circleRef; //get google.maps.Circle object
            //         const map = $circleObject.getMap();
            //         map.fitBounds($circleObject.getBounds());
            //     })
            // },
            updateCoordinates(latLng) {
	            this.outletMarker.location = {lat: latLng.lat(), lng: latLng.lng()}
	            if (!this.awaitingDrag) {
		            setTimeout(() => {
			            this.reverseGeocode(latLng.lat(), latLng.lng())
			            this.awaitingDrag = false;
		            }, 2000); // 1 sec delay
	            }
	            this.awaitingDrag = true;
            },

            async getOutletLocation() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const res = await this.$axios.get(this.$baseurl + "masterData/meta/data_detail_lokasi_outlet?idoutlet=" + this.idoutlet, this.requestHeaders)

                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()

                    if (res.data.data.latitude === 0 && res.data.data.longitude === 0) {
                        this.outletMarker.pinned = false;
	                    this.setMapContainer();
                    } else {
                        this.outletMarker.pinned = true;
                        this.outletMarker.location.lat = res.data.data.latitude;
                        this.outletMarker.location.lng = res.data.data.longitude;
                        this.radius = res.data.data.absen_radius;

                        await this.reverseGeocode(this.outletMarker.location.lat, this.outletMarker.location.lng)
	                    this.setMapContainer();
                    }
                } catch (e) {
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                    this.$catch_error_response(e)
                }
            },
            async updateOutletLocation() {
                this.isClicked = true
                $('#textBtnsavemap').hide()
                $('#Btnsavemap').prop('disabled', true);
                try {
                    var formData = new FormData();
                    formData.append("idoutlet", this.idoutlet);
                    formData.append("latitude", this.outletMarker.location.lat);
                    formData.append("longitude", this.outletMarker.location.lng);
                    formData.append("absen_radius", this.radius);
                    const res = await this.$axios.post(this.$baseurl + "masterData/outlet/update_location_outlet", formData, this.requestHeaders)
                    if (res.data.status) {
                        this.isClicked = false
                        $('#textBtnsavemap').show()
                        $('#Btnsavemap').prop('disabled', false);

                        this.$toast.success(res.data.msg)
                        this.back();
                    } else {
                        this.isClicked = false
                        $('#textBtnsavemap').show()
                        $('#Btnsavemap').prop('disabled', false);

                        this.$toast.error(res.data.msg)
                    }
                } catch (e) {
                    this.isClicked = false
                    $('#textBtnsavemap').show()
                    $('#Btnsavemap').prop('disabled', false);

                    this.$catch_error_response(e)
                }
            },
	        sync() {
		        this.mapCenter = this.outletMarker.location
	        },
	
	        getCurrentLocation() {
		        this.outletMarker.pinned = true
		        this.setMapContainer()
		        navigator.geolocation.getCurrentPosition(
			        position => {
				        this.outletMarker.location = {
					        lat: position.coords.latitude,
					        lng: position.coords.longitude,
				        }
				        
				        this.mapCenter = this.outletMarker.location
				        this.reverseGeocode(this.outletMarker.location.lat, this.outletMarker.location.lng)
			        },
			        error => {
				        this.$toast.error(error.message)
			        },
		        )
	        },
            async reverseGeocode(lat, lng) {
                try {
                    const res = await this.$axios.get("https://maps.googleapis.com/maps/api/geocode/json?" +
                        "latlng=" + lat + "," + lng +
                        "&key=" + this.$gmapKey
                    )
                    this.outletMarker.address = {
                        name: res.data.results[0].formatted_address,
                        full: res.data.results[0].formatted_address
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                }
            },
        }
    }
</script>

<style scoped>
    .hidesection {
        display: none;
    }

    .set-lokasi {
        padding: 10px 0 !important;
        cursor: pointer;
    }

    .border-dashed {
        border-top: 1px dashed #EDEDED;
    }

    .map-container {
        height: 100vh;
        width: 100%;
    }
    
    .current-location {
	    position: absolute;
	    bottom: 24px;
	    right: 12px;
	    background: #fff;
	    border: 1.5px solid #206CFF;
	    height: 48px;
	    width: 48px;
	    border-radius: 50%;
	    box-shadow: 0px 4px 21px -7px #000000
    }
    
    .current-location-img {
	    background-image: url('../../../assets/img/current-location.svg');
	    width: 100%;
	    height: 100%;
	    background-repeat: no-repeat;
	    background-position: center;
    }
</style>